module.exports = __webpack_public_path__ + "static/images/spike-yjs.1ef3425.png";